var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0013 15.667C5.3263 15.667 2.33464 12.6753 2.33464 9.00033C2.33464 5.32533 5.3263 2.33366 9.0013 2.33366C12.6763 2.33366 15.668 5.32533 15.668 9.00033C15.668 12.6753 12.6763 15.667 9.0013 15.667ZM9.83463 4.83366H8.16797V6.50033H9.83463V4.83366ZM9.83463 8.16699H8.16797V13.167H9.83463V8.16699Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0013 0.666992C4.4013 0.666992 0.667969 4.40033 0.667969 9.00033C0.667969 13.6003 4.4013 17.3337 9.0013 17.3337C13.6013 17.3337 17.3346 13.6003 17.3346 9.00033C17.3346 4.40033 13.6013 0.666992 9.0013 0.666992ZM9.0013 15.667C5.3263 15.667 2.33464 12.6753 2.33464 9.00033C2.33464 5.32533 5.3263 2.33366 9.0013 2.33366C12.6763 2.33366 15.668 5.32533 15.668 9.00033C15.668 12.6753 12.6763 15.667 9.0013 15.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dad708fe76d1835cb5426131948e9327.svg";
export { ForwardRef as ReactComponent };